export const gift = {
    gift_title: 'تطورك',
    gift_points_1 : 'لديك',
    gift_points_2 : 'نقاط',
    gift_find_gift: 'ابحث عن هديتي',
    milestone: "المرحلة",
    milestone_passed: "كان الاستبيان متاحًا خلال هذه الفترة.",
    milestone_available: "الاستبيان متاح الآن.",
    milestone_soon: "سيكون هذا الاستبيان متاحًا خلال {{count}} يوم{{plural}}.",
    milestone_reminder: "سوف تتلقى تذكيرًا عبر {{methods}}.",
}
